import { Pill } from '@/components/atoms'

export function PromiseBlock() {
	return (
		<section className="px-6 pt-6">
			<Pill>MI PROMESA ES:</Pill>

			<div className="mt-4 space-y-1 text-[12px] font-semibold tracking-widest text-[var(--brand-secondary)]">
				<p>HACER LAS PREGUNTAS</p>
				<p>QUE NADIE QUIERE</p>
				<p>HACER Y DECIR LO QUE</p>
				<p>NADIE QUIERE DECIR.</p>
			</div>
		</section>
	)
}
